import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";

import {useStationInfiniteQuery} from "./query";
import {debounce} from "../../../utils/debounce";

import MDInput from "materialDashboard/components/MDInput";

import Autocomplete from "@mui/material/Autocomplete";
import {getScrollHandler, LoadingAdornment} from "../utils";


const StationAutocomplete = ({ selectedStation, setSelectedStation, stationFilters={}, fieldProps={}, initializeFirst=false, waitFocus=true, ...props }) => {
    const {t} = useTranslation(["inputs"]);
    const hasAutoSelectedRef = useRef(false);

    const [hasFocus, setHasFocus] = useState(false);
    const [stationSearch, setStationSearch] = useState("");
    const stationSearchQuery = useStationInfiniteQuery({search: stationSearch, ...stationFilters}, !waitFocus || hasFocus);
    const stations = stationSearchQuery.data?.pages?.flatMap((page) => page.items) ?? []

    const handleStationSearch = debounce((value) => {
        setStationSearch(value);
    }, 300);

    const stationOptions = [
            ...(selectedStation ? [selectedStation] : []),
        ...stations.filter((s) => !selectedStation || selectedStation.id !== s.id),
    ]

    useEffect(() => {
        if (initializeFirst && !selectedStation && stations.length > 0 && !hasAutoSelectedRef.current) {
            setSelectedStation(stations[0]);
            hasAutoSelectedRef.current = true;
        }
    }, [initializeFirst, stations, setSelectedStation]);

    return <Autocomplete
        id="station-autocomplete"
        options={stationOptions}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(station) => `${station.code} - ${station.name}`}
        value={selectedStation}
        defaultValue={selectedStation}
        filterOptions={(x) => x}
        loading={stationSearch.isFetching}
        onChange={(e, value) => setSelectedStation(value)}
        onClose={() => handleStationSearch("")}
        onFocus={() => setHasFocus(true)}
        onBlur={() => setHasFocus(false)}
        ListboxProps={{onScroll: getScrollHandler(stationSearchQuery)}}
        renderInput={(params) => (
            <MDInput {...params}
                     onChange={(e) => handleStationSearch(e.target.value)}
                     variant="standard"
                     label={t('stationAutocomplete.label')}
                     placeholder={t('stationAutocomplete.placeholder')}
                     InputProps={{
                         ...params.InputProps,
                         endAdornment: (<LoadingAdornment infiniteQuery={stationSearchQuery} params={params}/> ),
                     }}
                     {...fieldProps}
            />
        )}
        {...props}
    />
}

export default StationAutocomplete;